import nls from '../../../../nls/pt-BR.json';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  removeClusters,
  removeMarkers,
  setDisplayCharts,
  setIsActive,
  setIsActiveRightSidebar,
} from '../../../../../redux/dashboardActions';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import {
  setCanAdvance,
  setCurrentProgressTo,
} from '../../../../redux/studies.reducer';

export const UnderstandPrimaryMarket: React.FC = () => {
  const [includeHeatmap, setIncludeHeatmap] = useState<boolean>(true);
  const { displayCharts } = useTypedSelector((state) => state.dashboardState);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch([
      setIsActive({ name: 'menuAction', value: '1' }),
      setIsActiveRightSidebar({ name: 'menuAction', value: '2' }),
      setCurrentProgressTo(1),
      setDisplayCharts(null),
      removeMarkers(),
      removeClusters(),
    ]);
  }, []);
  useEffect(() => {
    if (
      displayCharts === 'primaryMarket' ||
      displayCharts === 'primaryMarketEcoMap'
    ) {
      dispatch(setCanAdvance(true));
    } else {
      dispatch(setCanAdvance(false));
    }
  }, [displayCharts]);
  return (
    <>
      <p className="helper-text">{nls.studyCreationGuide.steps.step2.helper}</p>
      {/*Comentado até implementação da feature Mapas de calor*/}
      {/* <div>
        <Checkbox
          action={() => setIncludeHeatmap(!includeHeatmap)}
          cy="IncludeHeatmapPrimaryMarket"
          checked={includeHeatmap}
          name=""
          label={nls.studyCreationGuide.steps.step2.includeHeatmap}
        />
      </div> */}
    </>
  );
};
